var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsEmailBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "12px",
    viewBox: "0 0 14 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mail white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-Respondent",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Finish-Copy-6",
    transform: "translate(-24.000000, -372.000000)",
    fill: "#027DDD"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(16.000000, 368.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0001339,7.803 L22.0001339,14 C22.0001339,15.1045695 21.1047034,16 20.0001339,16 L10.0001339,16 C8.89556435,16 8,15.1045695 8,14 L8,7.803 L14.4701349,11.8479983 C14.7944052,12.0506672 15.2058625,12.0506672 15.5301328,11.8479983 L22.0001339,7.803 Z M20.0001339,4 C20.9277122,4 21.7078047,4.63146162 21.9339857,5.48795909 L15.0001339,9.82075236 L8.06654646,5.48695862 C8.29307057,4.63096992 9.07291675,4 10.0001339,4 L20.0001339,4 Z",
    id: "mail-white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsEmailBlue);
export default __webpack_public_path__ + "static/media/icons_email_blue.9d0eb71552aa071b75e1a12cbb74902a.svg";
export { ForwardRef as ReactComponent };